import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isPushAllowed, isPushReceivable } from 'state/Push'
import { FixedWarning } from './FixedWarning'

export default function DisabledPushAlert() {
	const { t } = useTranslation()

	const shouldBeOn = !useSelector(isPushReceivable) && isPushAllowed()

	return <FixedWarning long variant="danger" icon="bell-slash" show={shouldBeOn} btnTxt={t('Settings')} action="/settings">
		{t('Push notifications are currently turned off. Turn them on to make sure all order alerts are received.')}
	</FixedWarning>
}
